import { hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from './menu-item.gjs';

<template>
  <Menu
    @anchorElement={{@anchorElement}}
    @animated={{true}}
    @open={{@open}}
    data-test-spds-action-button-dropdown-menu
    role="menu"
  >
    {{yield
      (hash
        Item=(component
          MenuItem showSelectedStyles=false role="menuitem" toggleOpenState=@toggleOpenState
        )
      )
    }}
  </Menu>
</template>
